module.exports = __webpack_public_path__ + "static/img/cardRFID-1.9c39d96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/cardRFID-1.svg
// module id = NDdd
// module chunks = 0